exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-room[data-v-5b349a50] {\n  background: rgba(0, 0, 0, 0);\n  border: none;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 0;\n  width: 240px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b349a50","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR/RoomName.vue
// module id = qyok
// module chunks = 0